module.exports = __webpack_public_path__ + "static/media/daz.363652fb.svg";